import {useMutation} from '@tanstack/react-query';
import {useViewer} from 'bigdatr-style';
import formatViewerDataToHubspotData from '~/feature/notifications/formatViewerDataToHubspotData';
import {SubmitUserCreatedAccountFormMutationVariables} from '~/graphql-react-query/graphql';
import useClientMainAuthorizedFetch from '../clientMainAuthorisedFetch';
import {SubmitHubspotForm, SubmitUserCreatedAccountForm} from './graphqlQueries';

export function useSubmitHubspotForm() {
    const request = useClientMainAuthorizedFetch();
    const viewer = useViewer();

    return useMutation({
        mutationFn: async (input: {formId: string}) => {
            const data = formatViewerDataToHubspotData(viewer);
            const formInput = Object.entries(data).map(([fieldName, fieldValue]) => {
                return {
                    name: fieldName,
                    value: typeof fieldValue === 'string' ? fieldValue : JSON.stringify(fieldValue)
                };
            });
            const response = await request(SubmitHubspotForm, {
                formId: input.formId,
                formInput
            });
            if (typeof response.tracking?.submitHubspotForm !== 'boolean') {
                throw new Error('Failed to submit form');
            }
        }
    });
}

export function useSubmitUserCreatedAccountForm() {
    const request = useClientMainAuthorizedFetch();
    return useMutation({
        mutationFn: async (input: {
            country: SubmitUserCreatedAccountFormMutationVariables['country'];
        }) => {
            const response = await request(SubmitUserCreatedAccountForm, {country: input.country});
            if (typeof response.tracking?.submitUserCreatedAccountForm !== 'boolean') {
                throw new Error('Failed to submit form');
            }
        }
    });
}
